(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-features-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSpotlight(container) {
      const section = container || document.querySelector('.app-spotlight');
      if (!section) return;

      const cards = section.querySelectorAll('.spotlight__card');
      const phone = section.querySelector('.spotlight__phone');

      // Reset classes for re-initialization
      cards.forEach(c => c.classList.remove('spotlight__card--visible'));
      if (phone) phone.classList.remove('spotlight__phone--visible');

      if (window.innerWidth < 990) {
        cards.forEach(c => c.classList.add('spotlight__card--visible'));
        if (phone) phone.classList.add('spotlight__phone--visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            if (el.classList.contains('spotlight__phone')) {
              el.classList.add('spotlight__phone--visible');
            } else {
              el.classList.add('spotlight__card--visible');
            }
            observer.unobserve(el);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -60px 0px'
      });

      cards.forEach(card => observer.observe(card));
      if (phone) observer.observe(phone);
    }

    // Initial load
    initSpotlight();

    // Shopify theme editor events - reinitialize on section changes
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.app-spotlight')) {
        initSpotlight(event.target.querySelector('.app-spotlight'));
      }
    });

    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target.querySelector('.app-spotlight')) {
        initSpotlight(event.target.querySelector('.app-spotlight'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  // Properties toggle functionality
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-properties-toggle]');
    if (!toggle) return;

    const content = toggle.closest('.cart-item__properties').querySelector('[data-properties-content]');
    if (!content) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isExpanded);
    content.hidden = isExpanded;
  });

  // Remove item functionality
  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-remove-item]');
    if (!removeBtn) return;

    e.preventDefault();
    const lineIndex = parseInt(removeBtn.dataset.lineIndex);
    const cartItem = removeBtn.closest('.cart-item');

    // Add removing state
    if (cartItem) {
      cartItem.classList.add('cart-item--removing');
    }

    // Use Shopify Cart API to remove item
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Reload page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error removing item:', error);
      if (cartItem) {
        cartItem.classList.remove('cart-item--removing');
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const faqSection = document.querySelector('.faq');
    if (!faqSection) return;

    // Get all FAQ buttons (from both mobile and desktop cards)
    const allFaqButtons = faqSection.querySelectorAll('.faq__question');

    // Get the first card with keep-first-open attribute (could be mobile or desktop left card)
    const keepFirstOpenCards = faqSection.querySelectorAll('[data-keep-first-open]');
    const keepFirstOpen = keepFirstOpenCards.length > 0;

    // Get first button from each card type
    const mobileCard = faqSection.querySelector('.faq__card--mobile');
    const desktopLeftCard = faqSection.querySelector('.faq__card--left.faq__card--desktop');

    const mobileFirstButton = mobileCard ? mobileCard.querySelector('.faq__question') : null;
    const desktopFirstButton = desktopLeftCard ? desktopLeftCard.querySelector('.faq__question') : null;

    function openFirstItem() {
      // Check which card is visible (mobile or desktop) and open its first item
      const isMobileVisible = mobileCard && window.getComputedStyle(mobileCard).display !== 'none';
      const firstButton = isMobileVisible ? mobileFirstButton : desktopFirstButton;

      if (firstButton) {
        const firstAnswerId = firstButton.getAttribute('aria-controls');
        const firstAnswer = document.getElementById(firstAnswerId);
        if (firstAnswer) {
          firstButton.setAttribute('aria-expanded', 'true');
          firstAnswer.setAttribute('aria-hidden', 'false');
        }
      }
    }

    function closeAllItems() {
      allFaqButtons.forEach(btn => {
        const answerId = btn.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);
        if (answer) {
          btn.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function isFirstButton(button) {
      const isMobileVisible = mobileCard && window.getComputedStyle(mobileCard).display !== 'none';
      const firstButton = isMobileVisible ? mobileFirstButton : desktopFirstButton;
      return button === firstButton;
    }

    // Add click handler to all FAQ buttons
    allFaqButtons.forEach(button => {
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const answerId = button.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);
        const isFirst = isFirstButton(button);

        // Close all items first (ensures only one open across all cards)
        closeAllItems();

        // If the clicked item was closed, open it
        if (!expanded) {
          button.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        } else if (keepFirstOpen && isFirst) {
          // Allow first item to be closed
          // Do nothing - it's already closed
        } else if (keepFirstOpen && !isFirst) {
          // Re-open the first item
          openFirstItem();
        }
      });
    });

    // On initial load, open first item if keepFirstOpen is true
    if (keepFirstOpen) {
      openFirstItem();
    }

    // Re-check on window resize in case mobile/desktop card visibility changes
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (keepFirstOpen) {
          // Close all and re-open the first item for the current viewport
          closeAllItems();
          openFirstItem();
        }
      }, 150);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const header = document.getElementById('header-1');
    const menuToggle = document.getElementById('header1MenuToggle');
    const navDropdown = document.getElementById('header1NavDropdown');
    const allNavLinks = header ? header.querySelectorAll('.header-1__nav-link') : [];

    if (!header || !menuToggle || !navDropdown) return;

    function closeMenu() {
      menuToggle.classList.remove('active');
      menuToggle.setAttribute('aria-expanded', 'false');
      navDropdown.classList.remove('open');
      navDropdown.setAttribute('aria-hidden', 'true');
    }

    function openMenu() {
      menuToggle.classList.add('active');
      menuToggle.setAttribute('aria-expanded', 'true');
      navDropdown.classList.add('open');
      navDropdown.setAttribute('aria-hidden', 'false');
    }

    function toggleMenu() {
      const isOpen = menuToggle.classList.contains('active');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    // Update active link based on URL
    function updateActiveLink() {
      const hash = window.location.hash;
      const path = window.location.pathname;

      allNavLinks.forEach(function(link) {
        link.classList.remove('header-1__nav-link--active');
        const href = link.getAttribute('href');

        if (hash && href === hash) {
          link.classList.add('header-1__nav-link--active');
        } else if (!hash && href === path) {
          link.classList.add('header-1__nav-link--active');
        }
      });
    }

    window.addEventListener('hashchange', updateActiveLink);
    updateActiveLink();

    menuToggle.addEventListener('click', toggleMenu);

    navDropdown.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });

    allNavLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        allNavLinks.forEach(function(l) {
          l.classList.remove('header-1__nav-link--active');
        });
        this.classList.add('header-1__nav-link--active');
      });
    });

    document.addEventListener('click', function(e) {
      if (!header.contains(e.target)) {
        closeMenu();
      }
    });

    // Hide on scroll behavior
    const enableHideOnScroll = header.dataset.hideOnScroll === 'true';
    let lastScrollY = window.scrollY;
    let ticking = false;

    function handleScroll() {
      const currentScrollY = window.scrollY;

      closeMenu();

      // Add/remove scrolled class
      if (currentScrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      // Hide on scroll down, show on scroll up
      if (enableHideOnScroll && currentScrollY > 100) {
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // Scrolling down
          header.classList.add('header-1--hidden');
        } else if (currentScrollY < lastScrollY) {
          // Scrolling up
          header.classList.remove('header-1--hidden');
        }
      } else {
        header.classList.remove('header-1--hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }, { passive: true });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeMenu();
        menuToggle.focus();
      }
    });

    // ── Language switcher custom dropdown ──
    function initLangSwitcher(widgetId, formId, codeInputId, btnId, panelId) {
      var widget = document.getElementById(widgetId);
      var form = document.getElementById(formId);
      var input = document.getElementById(codeInputId);
      var btn = document.getElementById(btnId);
      var panel = document.getElementById(panelId);

      if (!widget || !form || !input || !btn || !panel) return;

      function openPanel() {
        // Close any other open lang panels first
        document.querySelectorAll('.header-1__lang-panel.is-open').forEach(function(p) {
          if (p !== panel) { p.classList.remove('is-open'); }
        });
        document.querySelectorAll('.header-1__lang-btn[aria-expanded="true"]').forEach(function(b) {
          if (b !== btn) { b.setAttribute('aria-expanded', 'false'); }
        });
        panel.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function() {
        if (panel.classList.contains('is-open')) {
          closePanel();
        } else {
          openPanel();
        }
      });

      panel.querySelectorAll('[data-value]').forEach(function(option) {
        option.addEventListener('click', function() {
          input.value = this.dataset.value;
          form.submit();
        });
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) {
          closePanel();
          btn.focus();
        }
      });
    }

    initLangSwitcher('header1LangWidget', 'Header1LangForm', 'Header1LangCode', 'header1LangBtn', 'header1LangPanel');

    // Close all lang panels on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header-1__lang')) {
        document.querySelectorAll('.header-1__lang-panel.is-open').forEach(function(p) {
          p.classList.remove('is-open');
        });
        document.querySelectorAll('.header-1__lang-btn[aria-expanded="true"]').forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initPricing(container) {
      const section = container || document.querySelector('[data-pricing-section]');
      if (!section) return;

      const toggle = section.querySelector('[data-pricing-toggle]');
      const labels = section.querySelectorAll('.pricing__toggle-label');
      const priceAmounts = section.querySelectorAll('.pricing__plan-price-amount');
      // Stacked design elements
      const stackedCompares = section.querySelectorAll('.pricing__stacked-compare');
      const stackedPrices = section.querySelectorAll('.pricing__stacked-price');

      function animateElement(el, firstVal, secondVal, period) {
        el.style.opacity = '0.4';
        setTimeout(() => {
          el.textContent = period === 0 ? firstVal : secondVal;
          el.style.opacity = '1';
        }, 150);
      }

      function updatePrices(period) {
        // Update main price displays (non-sale mode)
        priceAmounts.forEach(price => {
          animateElement(price,
            price.getAttribute('data-price-first'),
            price.getAttribute('data-price-second'),
            period
          );
        });

        // Stacked design: compare prices
        stackedCompares.forEach(compare => {
          animateElement(compare,
            compare.getAttribute('data-compare-first'),
            compare.getAttribute('data-compare-second'),
            period
          );
        });

        // Stacked design: sale prices
        stackedPrices.forEach(price => {
          animateElement(price,
            price.getAttribute('data-price-first'),
            price.getAttribute('data-price-second'),
            period
          );
        });
      }

      if (toggle) {
        toggle.addEventListener('click', () => {
          const isPressed = toggle.getAttribute('aria-pressed') === 'true';
          toggle.setAttribute('aria-pressed', !isPressed);

          // Update labels
          labels.forEach((label, index) => {
            if ((!isPressed && index === 1) || (isPressed && index === 0)) {
              label.classList.add('pricing__toggle-label--active');
            } else {
              label.classList.remove('pricing__toggle-label--active');
            }
          });

          // Update prices (isPressed was the OLD state, so !isPressed is new state)
          updatePrices(!isPressed ? 1 : 0);
        });

        // Make labels clickable
        labels.forEach((label, index) => {
          label.addEventListener('click', () => {
            const currentPressed = toggle.getAttribute('aria-pressed') === 'true';
            const shouldBePressed = index === 1;

            if (currentPressed !== shouldBePressed) {
              toggle.click();
            }
          });
        });
      }
    }

    // Initial load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPricing());
    } else {
      initPricing();
    }

    // Shopify theme editor events
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('[data-pricing-section]')) {
        initPricing(event.target.querySelector('[data-pricing-section]'));
      }
    });

    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target.querySelector('[data-pricing-section]')) {
        initPricing(event.target.querySelector('[data-pricing-section]'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const ctaButton = document.querySelector('[data-reveal-form]');
    const formContainer = document.querySelector('[data-form-container]');
    const form = document.querySelector('.product-form');
    const firstNameInput = document.querySelector('[data-field="first-name"]');
    const lastNameInput = document.querySelector('[data-field="last-name"]');
    const progressiveFields = document.querySelector('[data-progressive-fields]');
    const submitButton = document.querySelector('[data-add-to-cart]');
    const variantIdInput = document.querySelector('[data-variant-id]');
    const priceDisplay = document.querySelector('[data-price]');

    // Animate button when scrolled to via anchor link
    const getStartedSection = document.getElementById('get-started');
    const ctaButtonEl = getStartedSection?.querySelector('.btn');
    let scrollTimeout = null;
    let pendingAnimation = false;

    function triggerButtonAnimation() {
      if (ctaButtonEl) {
        ctaButtonEl.classList.remove('btn--attention');
        void ctaButtonEl.offsetWidth; // Force reflow to restart animation
        ctaButtonEl.classList.add('btn--attention');

        // Remove class after animation completes
        setTimeout(() => {
          ctaButtonEl.classList.remove('btn--attention');
        }, 1500);
      }
      pendingAnimation = false;
    }

    // Wait for scroll to fully stop before animating
    function waitForScrollStop() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(() => {
        if (pendingAnimation) {
          triggerButtonAnimation();
        }
      }, 150); // Wait 150ms after last scroll event
    }

    // Listen for scroll events when animation is pending
    function handleScrollForAnimation() {
      if (pendingAnimation) {
        waitForScrollStop();
      }
    }

    window.addEventListener('scroll', handleScrollForAnimation, { passive: true });

    // Listen for hash changes (when anchor links are clicked)
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#get-started') {
        pendingAnimation = true;
        waitForScrollStop();
      }
    });

    // Also trigger on page load if hash is present
    if (window.location.hash === '#get-started') {
      // Longer delay on page load to ensure scroll completes
      setTimeout(() => {
        pendingAnimation = true;
        waitForScrollStop();
      }, 100);
    }

    // Exit if critical elements don't exist
    if (!form || !submitButton || !firstNameInput || !lastNameInput) {
      console.error('Product form: Required elements not found');
      return;
    }

    // Reveal form when CTA button is clicked
    const ctaWrapper = document.querySelector('[data-cta-wrapper]');
    if (ctaButton && formContainer) {
      ctaButton.addEventListener('click', function() {
        if (ctaWrapper) {
          ctaWrapper.style.display = 'none';
        } else {
          ctaButton.style.display = 'none';
        }
        formContainer.style.display = 'block';
        firstNameInput.focus();
      });
    }

    // Show progressive fields when name fields are filled
    function checkNameFields() {
      if (!progressiveFields) return;

      if (firstNameInput.value.trim() && lastNameInput.value.trim()) {
        progressiveFields.style.display = 'flex';
      } else {
        progressiveFields.style.display = 'none';
      }
    }

    firstNameInput.addEventListener('input', checkNameFields);
    lastNameInput.addEventListener('input', checkNameFields);

    // Enable submit button when all required fields are filled
    function checkFormValidity() {
      const allInputs = form.querySelectorAll('input[required]');
      const allFilled = Array.from(allInputs).every(input => {
        // Skip progressive fields if they're hidden
        if (progressiveFields && input.closest('[data-progressive-fields]') && progressiveFields.style.display === 'none') {
          return true;
        }
        return input.value.trim() !== '';
      });

      submitButton.disabled = !allFilled;
    }

    form.addEventListener('input', checkFormValidity);

    // Form submission handling
    form.addEventListener('submit', function(e) {
      if (!submitButton.disabled) {
        submitButton.classList.add('product-form__submit--loading');
        submitButton.disabled = true;
      }
    });

    // Listen for variant changes from product-selector
    document.addEventListener('variantChanged', function(e) {
      if (e.detail && e.detail.variantId) {
        if (variantIdInput) {
          variantIdInput.value = e.detail.variantId;
        }
        updatePrice(e.detail.variantId);
      }
    });

    // Price map for variants
    const PRICE_MAP = {
      '51884725403924': '49',   // 6 months solo
      '51884725436692': '79',   // 6 months duo
      '51884725469460': '89',   // 12 months solo
      '51884725502228': '139'   // 12 months duo
    };

    function updatePrice(variantId) {
      if (priceDisplay && PRICE_MAP[variantId]) {
        priceDisplay.textContent = PRICE_MAP[variantId];
      }
    }

    // Initial form validity check
    checkFormValidity();

    // ==========================================
    // STICKY BOTTOM CTA - Scroll Detection
    // ==========================================
    const stickyCta = document.querySelector('[data-sticky-cta]');
    const productFormSection = document.querySelector('[data-product-form-section]');

    if (stickyCta && productFormSection) {
      // Only show on mobile (screens <= 768px)
      const isMobile = () => window.innerWidth <= 768;

      // Create intersection observer to detect when section is scrolled past
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!isMobile()) {
            stickyCta.classList.remove('sticky-cta--visible');
            return;
          }

          // Show sticky CTA when the section is NOT intersecting (scrolled past)
          // and the section is above the viewport (not below)
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
            stickyCta.classList.add('sticky-cta--visible');
          } else {
            stickyCta.classList.remove('sticky-cta--visible');
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      observer.observe(productFormSection);

      // Re-check on resize (mobile/desktop switch)
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (!isMobile()) {
            stickyCta.classList.remove('sticky-cta--visible');
          }
        }, 100);
      }, { passive: true });

      // Smooth scroll to section and reveal form when sticky CTA is clicked
      stickyCta.addEventListener('click', (e) => {
        e.preventDefault();

        // Hide sticky CTA immediately
        stickyCta.classList.remove('sticky-cta--visible');

        // Scroll to section first (block: 'center' so section appears in middle of viewport)
        productFormSection.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // After scroll completes, reveal the form
        setTimeout(() => {
          const ctaWrapperEl = document.querySelector('[data-cta-wrapper]');
          const formContainerEl = document.querySelector('[data-form-container]');
          const firstNameInputEl = document.querySelector('[data-field="first-name"]');

          // Check if form needs to be revealed
          if (ctaWrapperEl && formContainerEl && ctaWrapperEl.style.display !== 'none') {
            // Hide the CTA wrapper
            ctaWrapperEl.style.display = 'none';
            // Show the form
            formContainerEl.style.display = 'block';

            // Focus on the first input after form animation completes
            setTimeout(() => {
              if (firstNameInputEl) {
                firstNameInputEl.focus();
              }
            }, 800);
          }
        }, 600); // Wait for scroll to complete
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-selector"] && !Shopify.designMode) return;
  try {
    
  // Variant mapping: duration + plan = variant ID
  const VARIANT_MAP = {
    '6-solo': '51884725403924',
    '6-duo': '51884725436692',
    '12-solo': '51884725469460',
    '12-duo': '51884725502228'
  };

  // Current selections
  let selectedDuration = '6'; // Default: 6 months
  let selectedPlan = 'solo';  // Default: solo

  // Get current variant ID based on selections
  function getCurrentVariantId() {
    const key = `${selectedDuration}-${selectedPlan}`;
    return VARIANT_MAP[key];
  }

  // Update form variant and dispatch event
  function updateVariant() {
    const variantId = getCurrentVariantId();
    const event = new CustomEvent('variantChanged', {
      detail: {
        variantId: variantId,
        duration: selectedDuration,
        plan: selectedPlan
      }
    });
    document.dispatchEvent(event);
  }

  // Duration and plan selection logic
  document.addEventListener('DOMContentLoaded', function() {
    const durationButtons = document.querySelectorAll('[data-selector="duration"] .product-selector__option');
    const planButtons = document.querySelectorAll('[data-selector="plan"] .product-selector__plan');

    // Duration selection
    durationButtons.forEach(button => {
      button.addEventListener('click', function() {
        durationButtons.forEach(btn => btn.classList.remove('product-selector__option--active'));
        this.classList.add('product-selector__option--active');

        selectedDuration = this.dataset.duration;
        updateVariant();
      });
    });

    // Plan selection
    planButtons.forEach(button => {
      button.addEventListener('click', function() {
        planButtons.forEach(btn => btn.classList.remove('product-selector__plan--active'));
        this.classList.add('product-selector__plan--active');

        selectedPlan = this.dataset.plan;
        updateVariant();
      });
    });

    // Set initial variant on page load
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
(function() {
  class TrustStripScroller {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector('.trust-strip__scroll-wrapper');
      this.primaryTrack = section.querySelector('.trust-strip__track--primary');

      if (!this.wrapper || !this.primaryTrack) return;

      // Configuration
      this.speed = parseFloat(section.dataset.scrollSpeed) || 30;
      this.direction = section.dataset.scrollDirection === 'reverse' ? 1 : -1;
      this.pixelsPerSecond = 50; // Base speed

      // State
      this.currentPosition = 0;
      this.trackWidth = 0;
      this.isRunning = true;
      this.isPaused = false;
      this.rafId = null;
      this.lastTimestamp = null;

      this.init();
    }

    init() {
      // Calculate track width after fonts load
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.setup());
      } else {
        // Fallback for browsers without font loading API
        setTimeout(() => this.setup(), 100);
      }

      // Recalculate on resize
      this.resizeObserver = new ResizeObserver(() => {
        this.calculateTrackWidth();
      });
      this.resizeObserver.observe(this.section);

      // Pause on hover
      this.section.addEventListener('mouseenter', () => this.pause());
      this.section.addEventListener('mouseleave', () => this.resume());

      // Pause when not visible (performance)
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.resume();
            } else {
              this.pause();
            }
          });
        },
        { threshold: 0 }
      );
      this.intersectionObserver.observe(this.section);

      // Pause when tab not visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.resume();
        }
      });
    }

    setup() {
      this.calculateTrackWidth();
      this.ensureEnoughClones();
      this.section.classList.add('trust-strip--js-ready');
      this.start();
    }

    calculateTrackWidth() {
      // Get the actual rendered width of the primary track
      this.trackWidth = this.primaryTrack.offsetWidth;

      // Calculate speed: adjust pixelsPerSecond based on setting
      // Higher scroll_speed value = slower animation
      this.pixelsPerSecond = (this.trackWidth / this.speed);
    }

    ensureEnoughClones() {
      const viewportWidth = window.innerWidth;
      const tracks = this.wrapper.querySelectorAll('.trust-strip__track');
      let totalWidth = 0;

      tracks.forEach(track => {
        totalWidth += track.offsetWidth;
      });

      // We need at least 2x viewport width to ensure seamless loop
      const neededWidth = viewportWidth * 2.5;

      if (totalWidth < neededWidth) {
        const clonesNeeded = Math.ceil((neededWidth - totalWidth) / this.trackWidth);

        for (let i = 0; i < clonesNeeded; i++) {
          const clone = this.primaryTrack.cloneNode(true);
          clone.classList.remove('trust-strip__track--primary');
          clone.classList.add('trust-strip__track--clone');
          clone.setAttribute('aria-hidden', 'true');
          this.wrapper.appendChild(clone);
        }
      }
    }

    start() {
      if (this.rafId) return;
      this.lastTimestamp = null;
      this.animate();
    }

    animate(timestamp) {
      if (!this.isRunning) return;

      if (this.isPaused) {
        this.rafId = requestAnimationFrame((ts) => this.animate(ts));
        return;
      }

      if (!this.lastTimestamp) {
        this.lastTimestamp = timestamp;
      }

      const delta = timestamp - this.lastTimestamp;
      this.lastTimestamp = timestamp;

      // Calculate movement
      const movement = (this.pixelsPerSecond * delta) / 1000;
      this.currentPosition += movement * this.direction;

      // Reset position when we've scrolled one full track
      if (Math.abs(this.currentPosition) >= this.trackWidth) {
        this.currentPosition = this.currentPosition % this.trackWidth;
      }

      // Apply transform
      this.wrapper.style.transform = `translate3d(${this.currentPosition}px, 0, 0)`;

      this.rafId = requestAnimationFrame((ts) => this.animate(ts));
    }

    pause() {
      this.isPaused = true;
      this.section.classList.add('trust-strip--paused');
    }

    resume() {
      if (this.isPaused) {
        this.isPaused = false;
        this.lastTimestamp = null; // Reset timestamp to prevent jump
        this.section.classList.remove('trust-strip--paused');
      }
    }

    stop() {
      this.isRunning = false;
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    destroy() {
      this.stop();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }
  }

  // Initialize all trust strips with scroll animation
  function initTrustStrips() {
    const scrollStrips = document.querySelectorAll('.trust-strip--scroll');

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    scrollStrips.forEach(section => {
      // Don't reinitialize
      if (section.trustStripScroller) return;
      section.trustStripScroller = new TrustStripScroller(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustStrips);
  } else {
    initTrustStrips();
  }

  // Reinitialize on Shopify section events
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.trust-strip--scroll');
    if (section) {
      section.trustStripScroller = new TrustStripScroller(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.trust-strip--scroll');
    if (section && section.trustStripScroller) {
      section.trustStripScroller.destroy();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
